import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

// @source
import Router from '../../../modules/Router';

const Handover = ({ match }) => {
  const route = Router.store.find(item => item.handover === match.params.redirect);
  return route
    ? <Redirect to={route.path} />
    : <p style={{ padding: 15 }}>No pages to deliver</p>;
};

Handover.propTypes = {
  match: PropTypes.shape().isRequired,
};

export default Handover;
